import { CommonMessage } from '@frontend/lang';
import { PinCodeType } from '@frontend/pin-code/types';
import { ReactNode } from 'react';

import { PinCodeModalProps } from './pin-code-modal.component';

interface ViewProps {
    title: ReactNode;
}

const usePinCodeModal = (props: PinCodeModalProps): ViewProps => {
    if (props.pinCode?.type === PinCodeType.PICK_UP) {
        return { title: CommonMessage.OBJECTS.PIN_CODE.YOUR_PICK_UP_CODE };
    }
    if (props.pinCode?.type === PinCodeType.DROP_OFF) {
        return { title: CommonMessage.OBJECTS.PIN_CODE.YOUR_DROP_OFF_CODE };
    }
    return { title: CommonMessage.OBJECTS.PIN_CODE.DEFAULT };
};

export default usePinCodeModal;
